/** Angular material */
import {A11yModule} from '@angular/cdk/a11y';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';
import {Q9TrackDirective} from '@q9elements/ui-kit/common';

import {
  ContentLoaderComponent,
  IconButtonComponent,
  NodeSearchComponent,
  NotificationsModule,
  PrimaryButtonComponent,
  ReportsModule,
  SectionComponent,
  SupportButtonComponent,
  ThemeSwitcherComponent,
  ToolbarModule
} from '@q9elements/ui-kit/components';
import {ImpactToolbarComponent} from './components/impact-toolbar/impact-toolbar.component';
import {TitleSpinnerComponent} from './components/title-spinner/title-spinner.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    A11yModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatMenuModule,
    MatSelectModule,
    MatCheckboxModule,
    TranslateModule,
    MatTooltipModule,
    MatListModule,
    NgSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatRadioModule,
    ScrollingModule,
    MatAutocompleteModule,
    Q9TrackDirective,
    IconButtonComponent,
    NodeSearchComponent,
    NotificationsModule,
    PrimaryButtonComponent,
    ReportsModule,
    SectionComponent,
    SupportButtonComponent,
    ThemeSwitcherComponent,
    ToolbarModule,
    ContentLoaderComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatMenuModule,
    MatSelectModule,
    MatCheckboxModule,
    TranslateModule,
    MatTooltipModule,
    MatListModule,
    NgSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatRadioModule,
    MatAutocompleteModule,
    TitleSpinnerComponent,
    ImpactToolbarComponent,
    Q9TrackDirective
  ],
  declarations: [TitleSpinnerComponent, ImpactToolbarComponent]
})
export class SharedModule {}
